import { render, staticRenderFns } from "./SZValues.vue?vue&type=template&id=535904e5&scoped=true&"
import script from "./SZValues.vue?vue&type=script&lang=js&"
export * from "./SZValues.vue?vue&type=script&lang=js&"
import style0 from "./SZValues.vue?vue&type=style&index=0&id=535904e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535904e5",
  null
  
)

export default component.exports